export default {
	ACTIEF: 'ACTIEF',
	AFGEROND: 'AFGEROND',
	INACTIEF: 'INACTIEF'
};
